import React from 'react';
import { Box } from '@mui/material';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionSection.tsx';
import { normalizeDecimalValue } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { STATE_AID_BOOLEAN_FIELDS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/constants.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IStateAidAdditionalInfoSectionProps {
  agricultural: boolean;
  disabled: boolean;
  includesCovidSection: boolean;
}

export const StateAidAdditionalInfoSection: React.FC<IStateAidAdditionalInfoSectionProps> = ({
  agricultural,
  disabled,
  includesCovidSection,
}) => (
  <FinancialConditionSection
    title={includesCovidSection ? '5–8. Додаткова інформація' : '4–7. Додаткова інформація'}
  >
    <Box sx={documentGenerationFormStyles.section}>
      {STATE_AID_BOOLEAN_FIELDS.map((field) => (
        <FormCheckbox
          key={field.name}
          name={field.name}
          label={field.label}
          disabled={disabled}
          formControlLabelProps={{ sx: documentGenerationFormStyles.checkbox }}
        />
      ))}
      {agricultural && (
        <FormInput
          name="cultivatedArea"
          label="Площа обробки земельної ділянки, га"
          disabled={disabled}
          inputProps={{ inputMode: 'decimal' }}
          normalizeOnBlur={normalizeDecimalValue}
          sx={documentGenerationFormStyles.field}
        />
      )}
      <Box sx={documentGenerationFormStyles.fieldsGrid}>
        <FormInput name="signerPosition" label="Посада уповноваженої особи" disabled={disabled} fullWidth />
        <FormInput name="signerFullName" label="ПІБ уповноваженої особи" disabled={disabled} fullWidth />
      </Box>
    </Box>
  </FinancialConditionSection>
);
